// extracted by mini-css-extract-plugin
export default {"wrapper":"FormikTextInput_wrapper__+mAVO","error":"FormikTextInput_error__+nJhx","input":"FormikTextInput_input__wovL+","white":"FormikTextInput_white__Ec+Ax"};